<div class="user-coach-list-container">
  <div style="width: 100%;">
    <ag-grid-angular 
      style="height: 400px;"
      class="ag-theme-balham"
      [gridOptions]="gridOptions"
      [rowData]="$rowData | async"
      (rowClicked)="onRowClicked($event)">
    </ag-grid-angular>
  </div>
</div>